module.exports = __webpack_public_path__ + "static/img/banner3-3.e207640.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner3-3.jpg
// module id = FwsS
// module chunks = 1